import React from 'react';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import isMaster from '../../../utils/isMaster';
import {useRealtimeState} from '../../../realtime/RealtimeProvider';
import {
  fetchMaintenanceStatus,
  MAINTENANCE_QUERY_KEY,
} from '../../../utils/maintenanceApi';
import MaintenancePage from './MaintenancePage';

const badgeStyle = {
  position: 'fixed',
  right: 16,
  bottom: 16,
  zIndex: 2000,
  padding: '6px 12px',
  borderRadius: 16,
  background: '#ffc107',
  color: '#212529',
  fontSize: 12,
  fontWeight: 600,
  boxShadow: '0 2px 6px rgba(0,0,0,.25)',
};

// Shows the maintenance page to everyone except master accounts. /login stays
// reachable so a master can still sign in and switch maintenance off.
// Children stay mounted (just hidden) so unsaved form state survives.
const MaintenanceGate = ({ children }) => {
  const location = useLocation();
  useRealtimeState();
  const pollWithoutIdentity = () => {
    try {
      const token = JSON.parse(localStorage.getItem('user') || 'null');
      const account = JSON.parse(localStorage.getItem('name') || 'null');
      const clinic = JSON.parse(sessionStorage.getItem('selectedClinic') || 'null');
      return !(token && (account?.id || account?.userID) && clinic?.id);
    } catch {
      return true;
    }
  };
  const { data } = useQuery(MAINTENANCE_QUERY_KEY, fetchMaintenanceStatus, {
    refetchInterval: () => pollWithoutIdentity() ? 60 * 1000 : false,
    refetchIntervalInBackground: false,
    // Signed-in tabs get maintenance.invalidate over realtime; only anonymous
    // tabs (no realtime stream) still need focus refetches.
    refetchOnWindowFocus: () => pollWithoutIdentity(),
    staleTime: 15 * 1000,
    retry: false,
  });

  if (!data?.isActive) return children;

  if (isMaster() || location.pathname === '/login') {
    return (
      <>
        {children}
        <div style={badgeStyle}>
          {isMaster()
            ? 'Mode maintenance aktif — hanya master yang dapat mengakses'
            : 'Mode maintenance aktif — hanya akun master yang dapat masuk'}
        </div>
      </>
    );
  }

  return (
    <>
      <div style={{ display: 'none' }}>{children}</div>
      <MaintenancePage message={data.message} />
    </>
  );
};

export default MaintenanceGate;
